import React from 'react';

export const IconLoyaltyTiersLock = props => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M12.0013 5.66667H11.3346V4.33333C11.3346 2.49333 9.8413 1 8.0013 1C6.1613 1 4.66797 2.49333 4.66797 4.33333V5.66667H4.0013C3.26797 5.66667 2.66797 6.26667 2.66797 7V13.6667C2.66797 14.4 3.26797 15 4.0013 15H12.0013C12.7346 15 13.3346 14.4 13.3346 13.6667V7C13.3346 6.26667 12.7346 5.66667 12.0013 5.66667ZM6.0013 4.33333C6.0013 3.22667 6.89464 2.33333 8.0013 2.33333C9.10797 2.33333 10.0013 3.22667 10.0013 4.33333V5.66667H6.0013V4.33333ZM12.0013 13.6667H4.0013V7H12.0013V13.6667ZM8.0013 11.6667C8.73463 11.6667 9.33463 11.0667 9.33463 10.3333C9.33463 9.6 8.73463 9 8.0013 9C7.26797 9 6.66797 9.6 6.66797 10.3333C6.66797 11.0667 7.26797 11.6667 8.0013 11.6667Z"
      fill="#502314"
    />
  </svg>
);
